import { useGetAnswerCategory } from "@/api/app/assessment/useGetAnswerCategory";
import LoadingScreen from "@/components/Loading";
import AppContentContainer from "@/src/app/(auth)/_components/AppContentContainer";
import BottomBar from "@/src/app/(auth)/assessment/categories/[id]/_components/BottomBar";
import Heading from "@/src/app/(auth)/assessment/categories/[id]/_components/Heading";
import Overview from "@/src/app/(auth)/assessment/categories/[id]/_components/Overview";
import { useParams } from "react-router-dom";

function AssessmentCategory() {
  const { categoryId = "" } = useParams();

  const { data, isLoading } = useGetAnswerCategory(categoryId, {});

  if (isLoading || !data) {
    return <LoadingScreen />;
  }

  const { data: category, next, prev } = data.data;
  const questionsCount = category.answer_sub_categories.reduce(
    (acc, subCategory) => acc + subCategory.question_count,
    0,
  );

  return (
    <>
      <AppContentContainer
        className="px-32"
        bottomBar={
          <BottomBar
            previousLink={prev ? `/app/assessment/categories/${prev}` : ""}
            nextLink={next ? `/app/assessment/categories/${next}` : ""}
            backLink="/app/assessment"
          />
        }
      >
        <div className="pt-8 border-b pb-5">
          <div className="flex items-start justify-between gap-2">
            <Heading
              categoryName={category.content}
              subcategoriesCount={category.answer_sub_categories.length}
              questionsCount={questionsCount}
            />
          </div>
        </div>
        <div className="mt-8">
          <Overview data={category.answer_sub_categories} />
        </div>
      </AppContentContainer>
    </>
  );
}

export default AssessmentCategory;
